<nw-card
    class="content-card-container"
    [ngClass]="{
        'content-card-container--dark': theme === 'dark'
    }"
    [disabled]="!isClickable"
>
    <a [href]="clickableurl">
        <div class="content-card-container__title" role="header">
            <div>
                @if (icon) {
                    <img
                        class="content-card-container__title__icon"
                        [ngSrc]="icon"
                        height="24"
                        width="24"
                        [alt]="heading + ' card icon'"
                    />
                }
            </div>
            <div>
                {{ heading }}
            </div>
        </div>
        <div class="content-card-container__content" role="body">
            <div [innerHTML]="content | sanitizeHtml"></div>
        </div>
    </a>
</nw-card>
